<div (click)="close($event)" (keyup)="close($event)" tabindex=0 class="fixed top-0 left-0 h-screen w-screen bg-[#000] bg-opacity-40 z-40"
     [ngClass]="isActive? 'block' : 'hidden' ">
</div>

<div
    class="fixed bottom-0 left-0 w-full z-50 bg-white text-secondary
    transition-all rounded-t-2xl h-1/2 md:h-1/3 p-5 overflow-y-auto"
    [ngClass]="isActive? 'translate-y-0':'translate-y-full'"
    [attr.aria-hidden]="!isActive">
    <div class="flex w-full justify-end">
        <button (click)="close($event)"
                [attr.tabindex]="isActive ? '0' : '-1'"
                class="cursor-pointer"
                #closeIcon
                aria-label="Close Drawer">
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    </div>
    <ng-content />
    <button
        class="absolute w-0 h-0 p-0 overflow-hidden focus:w-px focus:h-px
        focus:overflow-visible focus:outline-none"
        [attr.tabindex]="isActive ? '0' : '-1'"
        (focus)="close($event)">Auto-Closing Button
    </button>
</div>

